const reducer = (
  state = {
    user: {},
    settings: {},
    opd: {},
    isFetchedUser: false,
    socket: {
      io : null,
      loadingCashier : false
    }
  },
  action
) => {
  switch (action.type) {
    case "UPDATE_USER":
      return {
        ...state,
        user: action.data,
      };
    case "UPDATE_SETTINGS":
      return {
        ...state,
        settings: action.data,
      };
    case "CREATE_OPD":
      return {
        ...state,
        opd: action.data,
      };
    case "IS_FETCH_USER":
      return {
        ...state,
        isFetchedUser: action.data,
      };
    case "SET_SOCKET":
      return {
        ...state,
        socket: action.data,
      };
    default:
      return state;
  }
};

export default reducer;
